// extracted by mini-css-extract-plugin
export default {"fullQuizItem":"FullQuizCreatorCard_fullQuizItem__yEsCA"};